import appSettings from "../../common/data/appSettings"
const ClientVersion = appSettings.ClientVersion

export default ClientVersion